/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('readableDate', () => (function(input, format = null) {
    moment.locale('fr');
    if (input == null) { return ''; }
    if (!input) { return input; }
    const humanized = moment(input, 'YYYY-MM-DD HH:mm:ss');
    if (humanized == null) { return input; }
    return humanized.format(null === format ? 'LLLL' : format);
}));
